export interface AppState {
  error               : any,
  returnHome          : boolean,
  loginInProcess      : boolean;
  verifyTotpInProcess : boolean;
  showClientsRequests : boolean,
};

export const initialState: AppState = {
  error: null,
  returnHome: false,
  loginInProcess: false,
  verifyTotpInProcess: false,
  showClientsRequests: false,
};